import { render } from "./AuthorizationPage.vue?vue&type=template&id=1e3335ac"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js"

import "./AuthorizationPage.vue?vue&type=style&index=0&id=1e3335ac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__